import { EReduxTypes } from 'ts/enums/redux.types';
import type { IMessageEvent } from 'ts/interfaces/common/events';
import type { IReduxAction } from 'ts/interfaces/redux/redux.action';

interface SseState {
  latestMessage: IMessageEvent | null;
}

const initialState: SseState = {
  latestMessage: null
};

const sseReducer = (state = initialState, action: IReduxAction) => {
  switch (action.type) {
    case EReduxTypes.SET_SSE_MESSAGE:
      return {
        ...state,
        latestMessage: action.data
      };
    case EReduxTypes.SET_SSE_FILE_TO_DOWNLOAD:
      return {
        ...state,
        sseFileToDownload: action.data
      };
    default:
      return state;
  }
};

export default sseReducer;
